import React, { useEffect, useState } from "react";
import useSWR from "swr";
import { useMobile } from "../../../hooks/useMobile";
import { fetcher } from "../../../utils/request";
import { pushDatatoAdobeLayer } from '../../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj } from '../../../analytics/analyticsObject';
import { getUrlWithoutPathname } from "../../../utils/utility"
let bookName = ""
let selectedItem = ""
const List = ({ contentKey = "", setContent, book, selectedSection }) => {
  bookName = book
  selectedItem = selectedSection;
  const { data } =
    useSWR(`api/tableofcontents/${contentKey}/language/EN`, fetcher, {
      revalidateOnFocus: false,
    }) || [];

  useEffect(() => {
    if (data) {
      setContent(
        getFragments(data.content)
          .sort((first, second) => first.order - second.order)
          .map(({ contentDetail }) => ({
            ...contentDetail,
            status: "Published",
            clickDisabled: true,
          }))
          .filter((item) => item.id !== null)
      );
    }
  }, [data]);

  if (!data)
    return (
      <div className="inline-block w-full text-center">
        <i className="fas fa-spin fa-spinner mr-3" />
      </div>
    );
  return (
    <div className={"list-div inline-block"}>
      <RootParent
        toclist={data.content}
        flatList={getFragments(data.content)}

      />
    </div>
  );
};

const getFragments = (members) => {
  let children = [];

  return members
    .map((m) => {
      if (m.children && m.children.length) {
        children = [...children, ...m.children];
      }
      return m;
    })
    .concat(children.length ? getFragments(children) : children);
};

const setActiveFragment = (item, data, index, length, isMobile) => {

  if (document.getElementById("fragments_list_" + item.order)) {
    for (let i = 0; i < data.length; i++) {
      if (document.getElementById("fragments_list_" + data[i].order))
        document
          .getElementById("fragments_list_" + data[i].order)
          .classList.remove("activeFragment");
    }
    for (let i = 0; i < length; i++) {
      if (document.getElementById("parent_" + i))
        document
          .getElementById("parent_" + i)
          .classList.remove("active-parent");
    }
    document.getElementById("parent_" + index).classList.add("active-parent");

    document
      .getElementById("fragments_list_" + item.order)
      .classList.add("activeFragment");
  }
  if (isMobile) {
    document.getElementById("rightpanel").classList.remove("rightpanel");
    document.getElementById("rightpanel").classList.add("rightpanel-full");
    document.getElementById("leftpanel").classList.remove("show");
    document.getElementById("table-of-content").classList.add("show");
    document.getElementById("leftpanel").classList.add("effect");
  }

  if (document.getElementById(item.contentDetail?.id))
    document
      .getElementById(item.contentDetail.id)
      .scrollIntoView({ behavior: "smooth" });
  let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
  let url = getUrlWithoutPathname()
  let customLObj = getAdobeAnalyticsCustomLinkObj(item.label, "tableofcontents:" + selectedItem + ":" + bookName.label, url);
  pushDatatoAdobeLayer({
    customLinkData: { ...customEventObj, ...customLObj },
    // pageData: false,
    adobePushTracking: false,
  });
};

const Child = ({ item, flatList, parentIndex, length }) => {
  const [show, setShow] = useState(true);
  const isMobile = useMobile();

  return (
    <>
      <div
        key={item.id}
        id={"fragments_list_" + item.order}
        className={`level ${"level-" + item.level} `}
        style={{ paddingLeft: item.level * 24 }}
        onClick={() => setActiveFragment(item, flatList, parentIndex, length, isMobile)}
        adoberegion="tableofcontents"
      >
        <span>{item.title}</span>
        {item.children?.length > 0 &&
          (show ? (
            <i
              className="fas fa-chevron-up align-middle float-right mr-3"
              onClick={(event) => {
                setShow((prevState) => !prevState);
                event.stopPropagation();
              }}
            ></i>
          ) : (
            <i
              className="fas fa-chevron-down align-middle float-right mr-3"
              onClick={(event) => {
                setShow((prevState) => !prevState);
                event.stopPropagation();
              }}
            ></i>
          ))}
      </div>
      {item.children?.length > 0 && show && (
        <div className="children">
          <ChildParent
            toclist={item.children}
            flatList={flatList}
            parentIndex={parentIndex}
            length={length}
          />
        </div>
      )}
    </>
  );
};

const ChildParent = ({ toclist, flatList, parentIndex, length }) => {
  return (
    <>
      {toclist?.map((item, index) => (
        <Child
          key={"child_parent_" + index}
          item={item}
          flatList={flatList}
          parentIndex={parentIndex}
          length={length}
        />
      ))}
    </>
  );
};

const RootParent = ({ toclist, flatList }) => {
  useEffect(() => {
    for (let i = 0; i < flatList.length; i++) {
      if (document.getElementById("fragments_list_" + flatList[i].order))
        document
          .getElementById("fragments_list_" + flatList[i].order)
          .classList.remove("activeFragment");
    }
    for (let i = 0; i < toclist.length; i++) {
      if (document.getElementById("parent_" + i))
        document
          .getElementById("parent_" + i)
          .classList.remove("active-parent");
    }
  }, [toclist]);
  return (
    <>
      {toclist?.map((item, index) => (
        <div id={"parent_" + index}>
          <Child
            key={"parent_root_" + index}
            item={item}
            flatList={flatList}
            parentIndex={index}
            length={toclist.length}

          />
        </div>
      ))}
    </>
  );
};

export default List;
